import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { UpcomingRevenueProjection, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseUpcomingRevenueProjectionProps {
  startDate: string | null;
  endDate: string | null;
}

function useUpcomingRevenueProjection({
  startDate,
  endDate,
}: IUseUpcomingRevenueProjectionProps): UseQueryResult<AxiosResponse<UpcomingRevenueProjection>> {
  const params: UrlParams = {};

  if (startDate !== null) {
    params.start_date = startDate;
  }
  if (endDate !== null) {
    params.end_date = endDate;
  }

  return useQuery(
    ['upcoming-revenue-projection', startDate, endDate],
    () => client.get(`reports/upcoming-revenue-projection/?${encodeUrlParams(params)}`),
    {
      enabled: startDate !== null && endDate !== null,
    },
  );
}

export default useUpcomingRevenueProjection;
